import React, { ComponentType } from 'react'
import { Container } from '@shared/components/container'
import { Faq } from '@shared/components/sections/faq'
import { FaqAccordionElement } from '@shared/components/sections/faq/model'

import { useNodeParams } from '../../hooks/useNodeParams'
import { AvailableComponentTypes, PageNodeViewModel } from '../../types'
import Head from 'next/head'

const stripHtml = (input: string) => {
	return input ? input.replace(/<\/?[^>]+(>|$)/g, '') : ''
}

interface MainEntity {
	'@type': 'Question'
	name: string
	acceptedAnswer: {
		'@type': 'Answer'
		text: string
	}
}

const jsonLd = (mainEntity: MainEntity[]) => ({
	'@context': 'https://schema.org',
	'@type': 'FAQPage',
	mainEntity,
})

interface Props {
	node: PageNodeViewModel
	Node: ComponentType<any>
}

export const NodeFaq = ({ node, Node }: Props) => {
	const nodeParams = useNodeParams(node.value.nodeParam)
	const items: FaqAccordionElement[] = nodeParams
		.get(AvailableComponentTypes.stringArray, '')
		.split('\n')
		.map((title, index) => {
			const nodeItem = (node.children || [])[index]
			return {
				title,
				content: <Node nodeViewModel={nodeItem} />,
			} as FaqAccordionElement
		})

	const value = nodeParams.get(AvailableComponentTypes.stringArray, '')

	const mainEntity = value.split('\n').reduce((acc, name, idx) => {
		if (node.children?.[idx].value.nodeParam[0])
			acc.push({
				'@type': 'Question',
				name,
				acceptedAnswer: {
					'@type': 'Answer',
					text: stripHtml(node.children[idx].value.nodeParam[0].value),
				},
			})
		return acc
	}, [] as Array<MainEntity>)

	return (
		<div className='mb-xl mt-l'>
			<Head>
				<script
					type='application/ld+json'
					dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd(mainEntity)) }}
				/>
			</Head>
			<Container>
				<Faq accordionElements={items} />
			</Container>
		</div>
	)
}
